import { IRaisePropertyChanged } from "bindable-data";

export class NotifyMap<K, V> extends Map<K, V> {
    public get name(): string {
        return this.propertyName;
    }

    public constructor(
        private readonly owner: IRaisePropertyChanged, 
        private readonly propertyName: string, 
        entries?: readonly (readonly [K, V])[] | null
    ) {
        super(entries);
    }
    
    public override clear(): void {
        super.clear();
        this.owner.raisePropertyChanged(this.propertyName);
    }

    public override delete(key: K): boolean {
        const value = super.delete(key);
        this.owner.raisePropertyChanged(this.propertyName);
        return value;
    }

    public override set(key: K, value: V): this {
        super.set(key, value);
        this.owner?.raisePropertyChanged(this.propertyName);
        return this;
    }
}